/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Replacevalue1Inputs */

const en_entity_replacevalue1 = /** @type {(inputs: Entity_Replacevalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace Value`)
};

const de_entity_replacevalue1 = /** @type {(inputs: Entity_Replacevalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wert ersetzen`)
};

/**
* | output |
* | --- |
* | "Replace Value" |
*
* @param {Entity_Replacevalue1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_replacevalue1 = /** @type {((inputs?: Entity_Replacevalue1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Replacevalue1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_replacevalue1(inputs)
	return de_entity_replacevalue1(inputs)
});
export { entity_replacevalue1 as "entity_replaceValue" }